import { View } from "react-native"
import { PropsWithChildren } from "react"

type SpacingProps = {
  top?: number
  left?: number
  right?: number
  bottom?: number
} & PropsWithChildren

export function Spacing(props: SpacingProps) {
  return (
    <View
      style={{
        marginTop: props.top || 0,
        marginLeft: props.left || 0,
        marginRight: props.right || 0,
        marginBottom: props.bottom || 0,
      }}
    >
      {props.children}
    </View>
  )
}
